<script>
	import { count } from '../stores.js';
	import { fade, crossfade } from 'svelte/transition'
	import { flip } from 'svelte/animate';

	const [send, receive] = crossfade({
		duration: (d) => Math.sqrt(d * 600),

		fallback(node, params) {
			const style = getComputedStyle(node)
			const transform = style.transform === 'none' ? '' : style.transform

			return {
				duration: 600,
				css: (t) => `
					transform: ${transform} scale(${t});
					opacity: ${t}
				`,
			}
		},
	})

	export let tierDetails, services, includedLabel, notIncludedLabel

	services.sort((a, b) => {
		return +a.package_tier > +b.package_tier ? 1 : -1
	})

	let selected;
	count.subscribe(value => {
		selected = +value;
	});

</script>

<div class="board">
	<div class="board-header">
		<div class="flex flex-col _items-center sm:flex-row items-start">
			<div class="board-header-img">
				{#if tierDetails[selected].img}
				<picture>
					<img class="!rounded-none" src="{tierDetails[selected].img.sizes.thumbnail}" width="{tierDetails[selected].img.sizes['thumbnail-width']}" height="{tierDetails[selected].img.sizes['thumbnail-height']}" alt="{tierDetails[selected].img.alt}" aria-hidden="true" />
				</picture>
				{/if}
			</div>
			<div class="board-header-content flex flex-col gap-4">
				{#if tierDetails[selected].header}
				<h2 class="title is-2" style="margin-bottom: 0">{tierDetails[selected].header}</h2>
				{/if}
				{#if tierDetails[selected].description}
				{@html tierDetails[selected].description}
				{/if}
			</div>
		</div>
	</div>

	<div class="top left">
		<p>{includedLabel}</p>
		{#each services.filter((pckg) => +pckg.package_tier <= selected + 1) as pckg (services.indexOf(pckg))}
			<a 
				href={pckg.url} 
				class="package-link inline-flex justify-between" 
				data-position={services.indexOf(pckg)} 
				in:receive={{ key: services.indexOf(pckg) }} 
				out:send={{ key: services.indexOf(pckg) }} 
				animate:flip="{{duration: 600}}"
				>
				{pckg.package_tier_alias && pckg.package_tier_alias[selected] && pckg.package_tier_alias[selected]['label'] ? pckg.package_tier_alias[selected]['label'] : pckg.alias ? pckg.alias : pckg.post_title}
			</a>
		{/each}
	</div>

	{#if services.filter((pckg) => +pckg.package_tier > selected + 1).length}
		<div class="bottom right">
			<p class="capitalize" transition:fade="{{duration: 50}}">{notIncludedLabel}</p>
			{#each services.filter((pckg) => +pckg.package_tier > selected + 1) as pckg (services.indexOf(pckg))}
				<a
					href={pckg.url}
					class="package-link done inline-flex justify-between"
					data-position={services.indexOf(pckg)}
					in:receive={{ key: services.indexOf(pckg) }}
					out:send={{ key: services.indexOf(pckg) }}
					animate:flip="{{duration: 600}}"
				>
					{pckg.package_tier_alias && pckg.package_tier_alias[selected] && pckg.package_tier_alias[selected]['label'] ? pckg.package_tier_alias[selected]['label'] : pckg.alias ? pckg.alias : pckg.post_title}
				</a>
			{/each}
		</div>
	{/if}
</div>
